import type {
  PromotionLogicalCondition as LogicalCondition,
  PromotionData
} from '@futureecom/futureecom-js/dist/services/promotion-service'

export const isConditionLogical = (val: PromotionData['condition']): val is LogicalCondition => {
  const condition = val || {}
  return 'logicalOperator' in condition && !('rule' in condition)
}
